<div #container class="flex w-full min-w-0 items-center gap-1 overflow-hidden whitespace-nowrap">
  @for (tag of visibleTags; track tag.id) {
    <app-tag #tagElement [tag]="tag" [compact]="compact" />
  }
  @if (hiddenTagsCount) {
    <span [class]="compact
                     ? 'inline-flex shrink-0 items-center self-center rounded-full px-1.5 py-px text-xs leading-normal'
                     : 'inline-flex shrink-0 items-center self-center rounded-full px-1.5 py-px text-xs leading-normal'"
          [ngClass]="selected ? 'bg-white text-[var(--primary-color)]' : 'bg-slate-500 text-white'"
          [attr.title]="hiddenTagsTitle">
      +{{ hiddenTagsCount }}
    </span>
  }
</div>

<span #counterMeasure
      [class]="compact
                   ? 'pointer-events-none absolute invisible inline-flex items-center rounded-full px-1.5 py-px text-xs leading-normal whitespace-nowrap'
                   : 'pointer-events-none absolute invisible inline-flex items-center rounded-full px-1.5 py-px text-xs leading-normal whitespace-nowrap'"
      [ngClass]="selected ? 'bg-white text-[var(--primary-color)]' : 'bg-slate-500 text-white'">
  +{{ tags.length }}
</span>
